import { StatsTotalCard } from "./StatsTotalCard";
export default StatsTotalCard;
